/**
 * Generated bundle index. Do not edit.
 */

export {BootstrapModalSize,BSModalContext,BSModalContextBuilder,BSModalContainer,BSMessageModal,BSMessageModalTitle,BSMessageModalBody,BSModalFooter,BSMessageModalButtonConfig,BSMessageModalButtonHandler,MessageModalPreset,MessageModalPresetBuilder,ModalOpenContext,ModalOpenContextBuilder,OneButtonPreset,OneButtonPresetBuilder,TwoButtonPreset,TwoButtonPresetBuilder,PromptPreset,PromptPresetBuilder,Modal,bootstrap4Mode,BootstrapModalModule,providers} from './bootstrap';

export {AbstractTwoButtonPresetBuilder as ɵa} from './presets/two-button-preset';